import { createContext, useState } from "react";

export const ThemeContext = createContext();

const getThemeKey = () => {
  try {
    const item = localStorage.getItem("theme");
    if (!item) return "Light";
    const themeData = JSON.parse(item);
    if (typeof themeData === "string") return themeData;
    return themeData?.title || "Light";
  } catch (e) {
    const item = localStorage.getItem("theme");
    return item || "Light";
  }
};

export const ThemeProvider = ({ children }) => {
  const themes = {
    Light: {
      background2: "#70CEEA",
      background: "#1c2b40",
      hover: "#4a90e226",
      sidebar: "#1c2b40"
    },
    Dark: {
      background2: "#95a5a6",
      background: "#424242",
      hover: "#767a88",
      sidebar: "#181818"
    }
  };

  const [themedColor, setThemedColor] = useState(() => {
    const themeKey = getThemeKey();
    return themes[themeKey] || themes.Light;
  });

  const updateTheme = () => {
    const themeKey = getThemeKey();
    setThemedColor(themes[themeKey] || themes.Light);
  };

  return (
    <ThemeContext.Provider value={{ themedColor, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

